import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminGuardService } from '../auth/services/admin-guard.service';
import { AuthGuardService } from '../auth/services/auth-guard.service';
import { AdminComponent } from './pages/admin/admin.component';
import { DashboardPage } from './pages/dashboard/dashboard.page';
import { DaysComponent } from './pages/days/days.component';
import { MessageComponent } from './pages/message/message.component';
import { MessagesComponent } from './pages/messages/messages.component';
import { TrackProgressComponent } from './pages/track-progress/track-progress.component';
import { WeeksPage } from './pages/weeks/weeks.page';
import { WorkoutPage } from './pages/workout/workout.page';
import { WorkoutsPage } from './pages/workouts/workouts.page';

const routes: Routes = [
  {
    canActivate: [AuthGuardService, AdminGuardService],
    path: 'admin',
    component: AdminComponent
  },
  {
    canActivate: [AuthGuardService, AdminGuardService],
    path: 'manager',
    component: TrackProgressComponent
  },
  {
    canActivate: [AuthGuardService],
    path: 'dashboard',
    component: DashboardPage
  },
  {
    canActivate: [AuthGuardService],
    path: 'days/:week_id',
    component: DaysComponent
  },
  {
    canActivate: [AuthGuardService],
    path: 'weeks',
    component: WeeksPage
  },
  {
    canActivate: [AuthGuardService],
    path: 'workouts/:week_id',
    component: WorkoutsPage
  },
  {
    canActivate: [AuthGuardService],
    path: 'workouts/:week_id/:workout_id',
    component: WorkoutPage
  },
  {
    canActivate: [AuthGuardService],
    path: 'messages',
    component: MessagesComponent
  },
  {
    canActivate: [AuthGuardService],
    path: 'messages/:week_number',
    component: MessageComponent
  },
  {
    canActivate: [AuthGuardService],
    path: '',
    component: DashboardPage
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoggedRoutingModule { }
